import styled from '@emotion/styled'
import React, { forwardRef, type HTMLProps } from 'react'
import {
  callCenterInternationalPhoneNumber,
  callCenterInternationalPhoneNumberText,
  callCenterPhoneNumber,
  callCenterPhoneNumberText,
} from '@mobi/utils/phone'
import { colors } from '@mobi/component-library/Foundations'
import { serviceCenterEmail } from '@mobi/utils/email'

export const CustomerServiceCentre = ({
  prefixText,
  suffixText,
  onClickPhoneNumber,
}: {
  prefixText?: string
  suffixText?: string
  onClickPhoneNumber?: () => void
}) => (
  <div>
    {prefixText ?? ''} Please contact our Customer Service Centre on{' '}
    <CustomerServiceTelephone onClick={onClickPhoneNumber} /> for more information{' '}
    {suffixText ?? ''}
  </div>
)

type Props = HTMLProps<HTMLAnchorElement> & { isInternational?: boolean }

export const CustomerServiceTelephone = forwardRef<HTMLAnchorElement, Props>(
  ({ isInternational, onClick }, ref) => {
    const { linkText, text } = isInternational
      ? {
          linkText: callCenterInternationalPhoneNumber,
          text: callCenterInternationalPhoneNumberText,
        }
      : { linkText: callCenterPhoneNumber, text: callCenterPhoneNumberText }

    return (
      <LinkStyled href={linkText} ref={ref} onClick={onClick}>
        {text}
      </LinkStyled>
    )
  }
)

export const CustomerServiceEmail = () => (
  <LinkStyled href={`mailto:${serviceCenterEmail}`}>{serviceCenterEmail}</LinkStyled>
)

CustomerServiceTelephone.displayName = 'CustomerServiceTelephone'

const LinkStyled = styled.a({
  color: colors.studio[500],
})
